export default __webpack_public_path__ + "static/media/August2008.9f96f8d0.png";